export const getAnalyticsItemCategoriesByTaxonomy = (
  taxonomy: string[] = [],
  prefix?: string,
) => {
  const itemCategory: string[] = [];
  const itemCategory2: string[] = [];
  const itemCategory3: string[] = [];

  taxonomy.forEach((value) => {
    const splittedTaxonomy = value.split('>') ?? [];

    if (splittedTaxonomy[0] && !itemCategory.includes(splittedTaxonomy[0])) {
      itemCategory.push(splittedTaxonomy[0]);
    }
    if (splittedTaxonomy[1] && !itemCategory2.includes(splittedTaxonomy[1])) {
      itemCategory2.push(splittedTaxonomy[1]);
    }
    if (splittedTaxonomy[2] && !itemCategory3.includes(splittedTaxonomy[2])) {
      itemCategory3.push(splittedTaxonomy[2]);
    }
  });

  const baseResult = {
    item_category: itemCategory.join(', '),
    item_category2: itemCategory2.join(', '),
    item_category3: itemCategory3.join(', '),
  };

  if (prefix) {
    return Object.fromEntries(
      Object.entries(baseResult).map(([key, value]) => [
        `${prefix}${key}`,
        value,
      ]),
    );
  }

  return baseResult;
};
